import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import styled from '@emotion/styled'
import * as serviceWorker from './application/serviceWorker'
import Data from '../package.json'
import 'application/constants/globals'

const VersionBlock = styled('div')`
  position: relative;
  color: #565656;
  font-size: 11px;
  opacity: 0.5;
  justify-content: end;
  display: flex;
`

ReactDOM.render(
  <React.StrictMode>
    <App />
    <VersionBlock>DEP - {Data.version}</VersionBlock>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
